import React from 'react';

/**
 * Persistent heads-up for early testers — mounted once at the app root so it
 * shows on every screen for the duration of the testing period.
 */
export default function DevBanner() {
  return (
    <div className="w-full bg-amber-400 py-1 text-center text-xs font-semibold text-amber-950">
      Development in progress. Changes may occur at any time without warning.
    </div>
  );
}
